<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div slot="no-body">
		<vs-navbar
			v-model="activeItem"
			color="primary"
			text-color="rgba(255,255,255,.6)"
			active-text-color="rgba(255,255,255,1)"
			class="myNavbar cursor-pointer"
		>
			<vs-navbar-item :index="0">
				<a :class="activeItem === 0 ? 'font-bold' : 'font-semibold'">
					{{ $t("TimeWindow.DayOfWeek") }}
				</a>
			</vs-navbar-item>
			<vs-navbar-item :index="1">
				<a :class="activeItem === 1 ? 'font-bold' : 'font-semibold'">
					{{ $t("TimeWindow.DayOfMonth") }}
				</a>
			</vs-navbar-item>
			<vs-navbar-item :index="2">
				<a :class="activeItem === 2 ? 'font-bold' : 'font-semibold'">
					{{ $t("TimeWindow.Month") }}
				</a>
			</vs-navbar-item>
			<vs-navbar-item :index="3">
				<a :class="activeItem === 3 ? 'font-bold' : 'font-semibold'">
					{{ $t("TimeWindow.Hours") }}
				</a>
			</vs-navbar-item>
			<vs-navbar-item :index="4">
				<a :class="activeItem === 4 ? 'font-bold' : 'font-semibold'">
					{{ $t("TimeWindow.Minutes") }}
				</a>
			</vs-navbar-item>
		</vs-navbar>
		<transition name="fade">
			<div class="tab-text" v-show="activeItem === 0">
				<day-week
					:is-edit="true"
					:cronExpressionDayWeek="dataFrequencies.cron.split(' ')[4]"
					@resultDayWeekEmit="resultDayWeek"
				/>
			</div>
		</transition>
		<transition name="fade">
			<div class="tab-text" v-show="activeItem === 1">
				<day-month
					:is-edit="true"
					:cronExpressionDayMonth="dataFrequencies.cron.split(' ')[2]"
					@resultDayMonthEmit="resultDayMonth"
				/>
			</div>
		</transition>
		<transition name="fade">
			<div class="tab-text" v-show="activeItem === 2">
				<Monthly
					:is-edit="true"
					:cronExpressionMonth="dataFrequencies.cron.split(' ')[3]"
					@resultMonthEmit="resultMonth"
				/>
			</div>
		</transition>
		<transition name="fade">
			<div class="tab-text" v-show="activeItem === 3">
				<hourly
					:is-edit="true"
					:cronExpressionHour="dataFrequencies.cron.split(' ')[1]"
					@resultHourEmit="resultHour"
				/>
			</div>
		</transition>
		<transition name="fade">
			<div class="tab-text" v-show="activeItem === 4">
				<minute
					:is-edit="true"
					:cronExpressionMinute="dataFrequencies.cron.split(' ')[0]"
					@resultMinuteEmit="resultMinute"
				/>
			</div>
		</transition>
	</div>
</template>

<script>
import {generalPurposeMixin} from "@/mixins/generalPurposeMixin.js";
import {FormWizard, TabContent} from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

export default {
	name: "FrequencyEditCron",
	mixins: [generalPurposeMixin],
	components: {
		FormWizard,
		TabContent,
	},
	props: {
		dataFrequencies: {
			type: Object,
			default: "",
		},
	},
	data() {
		return {
			activeTab: 0,
			cronDayWeek: "*",
			cronDayMonth: "*",
			cronMonth: "*",
			cronHour: "0",
			cronMinute: "0",
			activeItem: 0,
		};
	},
	computed: {
		cronExpression() {
			return `${this.cronMinute} ${this.cronHour} ${this.cronDayMonth} ${this.cronMonth} ${this.cronDayWeek}`;
		},
	},
	mounted() {
		this.getEvents(this.dataFrequencies.cron);
	},
	watch: {
		cronDayMonth(newVal) {
			if (this.dataFrequencies.cron.split(" ")[2] !== newVal) this.getEvents(this.cronExpression);
		},
		cronDayWeek(newVal) {
			if (this.dataFrequencies.cron.split(" ")[4] !== newVal) this.getEvents(this.cronExpression);
		},
		cronMonth(newVal) {
			if (this.dataFrequencies.cron.split(" ")[3] !== newVal) this.getEvents(this.cronExpression);
		},
		cronHour(newVal) {
			if (this.dataFrequencies.cron.split(" ")[1] !== newVal) this.getEvents(this.cronExpression);
		},
		cronMinute(newVal) {
			if (this.dataFrequencies.cron.split(" ")[0] !== newVal) this.getEvents(this.cronExpression);
		},
		cronExpression(val) {
			this.dataFrequencies.cron = val;
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		resultDayMonth(val) {
			this.cronDayMonth = val;
			this.$store.commit("frequency/SET_CRON_EXPRESSION", this.cronExpression);
		},
		resultDayWeek(val) {
			this.cronDayWeek = val;
			this.$store.commit("frequency/SET_CRON_EXPRESSION", this.cronExpression);
		},
		resultMonth(val) {
			this.cronMonth = val;
			this.$store.commit("frequency/SET_CRON_EXPRESSION", this.cronExpression);
		},
		resultHour(val) {
			this.cronHour = val;
			this.$store.commit("frequency/SET_CRON_EXPRESSION", this.cronExpression);
		},
		resultMinute(val) {
			this.cronMinute = val;
			this.$store.commit("frequency/SET_CRON_EXPRESSION", this.cronExpression);
		},
		addDaysToDate(stringDate, dayNums) {
			const date = new Date(stringDate);
			return date.setDate(date.getDate() + dayNums);
		},
		getEvents(cron) {
			const payload = {
				init_date: this.dateInitComputed,
				end_date: this.dateFinalComputed,
				end_hour: "23:59:59",
				init_hour: "00:00:00",
				time_windows: [
					{
						cron_exp: cron,
						duration: this.dataFrequencies.duration,
					},
				],
			};
			this.$store
				.dispatch("moduleTimeWindow/findTimeWindowSimulate", payload)
				.then((res) => {
					if (res.data[0] === "invalid cron expression") {
						this.$vs.notify({
							color: "warning",
							title: this.$t("TimeWindow.Schedule"),
							text: this.$t("TimeWindow.TheChosenTimeIsNotValid"),
							time: 7000,
						});
					}
					return res;
				})
				.catch((err) => {
					console.error(err);
				});
		},
	},
};
</script>
<style lang="scss" scoped>
.vs-navbar-gradient .vs-navbar-item-primary.is-active-item {
	border-radius: 6px;
	color: #fff !important;
	background: rgba(var(--vs-primary), 1);
}

.vs-navbar {
	-webkit-box-shadow: none;
	box-shadow: none;
}

.vs-navbar-gradient {
	border: 1px solid rgba(0, 0, 0, 0.05);
}

.vs-navbar-gradient .vs-navbar--item {
	border-left: 1px solid rgba(0, 0, 0, 0.05);
}
</style>
